import superMeta from '../_ABSTRACT/metaAbstractNode.mjs'

export default {
    ...superMeta,
    name: '数据库实例',
    type: 'DBINS_',
}
